import { render } from "./BitacoraList.vue?vue&type=template&id=782f113f&scoped=true"
import script from "./BitacoraList.vue?vue&type=script&lang=js"
export * from "./BitacoraList.vue?vue&type=script&lang=js"

import "./BitacoraList.vue?vue&type=style&index=0&id=782f113f&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782f113f"]])

export default __exports__